<template>
  <!-- Default cms slots -->
  <slot v-bind="{toggleFiltersState, viewBreakpointLessThan, viewBreakpointMoreThan, areFiltersVisible}"></slot>
</template>

<script>
import {mapState, mapGetters, mapMutations} from 'vuex';

export default {
  name: 'PlpFacetRefinementsWrapper',

  props: {
    marqueeData: {
      type: Object,
      default: () => null,
    },
  },

  computed: {
    ...mapGetters('viewSize', ['viewBreakpointLessThan', 'viewBreakpointMoreThan']),
    ...mapState('plp', ['areFiltersVisible']),
  },

  methods: {
    ...mapMutations('plp', ['setAreFiltersVisible']),
    toggleFiltersState() {
      this.setAreFiltersVisible(!this.areFiltersVisible);
    },
  },
};
</script>
